import CoursesMenu from "./courses-menu";
import {throttle} from "../../../lib";
import SearchController from "./search-controller";
import CategoryController from "./category-controller";

export default class CoursesMenuMobile extends CoursesMenu {
	constructor($root) {
		super($root);
		this.$mobileNavMenuSections = null;
		this.$coursesMenuMobile = null;
		this.$searchControl = null;
		this.$searchCancelBtn = null;

		this.activeScreenId = null;
		this.searchFieldBaseWidth = body.offsetWidth - 30;
		this.searchFieldActive = false;
	}

	defineViews() {
		this.$mobileNavMenuSections = document.getElementById('mobileNavMenuSections');
		this.$coursesMenuMobile = document.getElementById('coursesMenuMobile');
		this.$searchField = document.getElementById('coursesMenuMobileSearchField');
		this.$searchControl = this.$coursesMenuMobile.querySelector('.search-control');
		this.$searchCancelBtn = document.getElementById('coursesMenuMobileSearchCancel');
		this.$categoriesMenu = document.getElementById('coursesMenuMobileControlPanel');
		this.$searchPanel = document.getElementById('coursesMenuMobileSearchPanel');
	}

	addComponents() {
		this.searchController = new SearchController(this.$searchField, this.$searchPanel, { mobile: true });
		this.categoryController = new CategoryController(this.$categoriesMenu);
	}

	addEventListeners() {
		super.addEventListeners();
		this.addSearchCancelListener();
		this.addSearchFieldResize();
	}

	addSearchCancelListener() {
		this.$searchCancelBtn.addEventListener('click', this.cancelSearch.bind(this));
	}

	addSearchFieldResize() {
		window.addEventListener('resize', throttle(() => {
			this.searchFieldBaseWidth = this.$root.offsetWidth;
			this.resizeSearchField();
		}, 10));
	}

	cancelSearch() {
		this.searchController.setInputInitialState();
		this.deactivateSearchPanel();
	}

	activateSearchPanel() {
		this.searchFieldBaseWidth = this.$root.offsetWidth;
		this.searchFieldActive = true;
		this.$coursesMenuMobile.classList.add('-search');
		this.$searchControl.classList.add('-search');

		this.resizeSearchField();
	}

	deactivateSearchPanel() {
		this.searchFieldActive = false;
		this.$coursesMenuMobile.classList.remove('-search');
		this.$searchControl.classList.remove('-search');

		this.resizeSearchField();
	}

	resizeSearchField() {
		if (this.searchFieldActive) {
			const activeControlOffset = this.$searchCancelBtn.offsetWidth + 10;
			this.$searchField.style.width = `${this.searchFieldBaseWidth - activeControlOffset}px`;
		} else {
			this.$searchField.style.width = `${this.searchFieldBaseWidth}px`;
		}
	}

	setActiveScreen(id) {
		super.setActiveScreen(id);
		this.$mobileNavMenuSections.dataset.active = 'courses-nav';
	}
}